import { getMmtAuth } from '../userDetailsUtils';
import { trackAdView } from '../utils/omnitureTracking';
export const CABS_SEO_AD_CONTEXT_ID = 'Q0FCI1NFTyNCT0RZ';
export const CABS_LANDING_PAGE_SNACKBAR_CONTEXT_ID =
  'Q0FCI0xBTkRJTkcjU05BQ0tCQVI=';

export const config = {
  userCallbackForView: contextId => {
    const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
    setTimeout(
      () =>
        trackAdView(
          isMobileDevice
            ? `Mob_Cab_SEO_Template_Ad_${contextId}_Viewed`
            : `Cab_SEO_Template_Ad_${contextId}_Viewed`
        ),
      2000
    );
  },

  ORG: 'MMT',
  AUTH_COOKIE_KEY: 'mmt-auth',
  AUTHORIZATION: 'DFjgkXbgFGBvebc',
  AUTHORITY: 'adorch.makemytrip.com',
  mode: 'PROD',
  API_CALL: 'SINGLE'
};

export const landingConfig = {
  userCallbackForView: contextId => {
    const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
    setTimeout(
      () =>
        trackAdView(
          isMobileDevice
            ? `Mob_Cab_SEO_Landing_Ad_${contextId}_Viewed`
            : `Cab_SEO_Landing_Ad_${contextId}_Viewed`
        ),
      2000
    );
  },

  ORG: 'MMT',
  AUTH_COOKIE_KEY: getMmtAuth() || 'mmt-auth',
  AUTHORIZATION: 'DFjgkXbgFGBvebc',
  AUTHORITY: 'adorch.makemytrip.com',
  mode: 'PROD',
  API_CALL: 'SINGLE'
};
